import { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import {
  initializeFirebase,
  pageViewEvent,
} from 'shared/services/TrackingGAService'

const useGaTracker = (): void => {
  const location = useLocation()
  const [initialized, setInitialized] = useState(false)

  useEffect(() => {
    if (process.env.NODE_ENV !== 'test') {
      initializeFirebase()
    }
    setInitialized(true)
  }, [])

  useEffect(() => {
    if (initialized) {
      pageViewEvent({
        title: location.pathname,
        path: location.pathname,
      })
    }
  }, [initialized, location])
}

export default useGaTracker
